import { useLocation } from "react-router-dom";
import TeamCard from "../components/teamCard/teamCard";

export default function TeamCardPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const type = params.get("type"); // ligue / teams / sports
  const sport = params.get("sport"); // soccer / tenis
  const idEvent = params.get("idEvent");

  return (
    <TeamCard type={type} sport={sport} idEvent={idEvent} />
  )

}